import { FC } from 'react';
import { IconProps } from '../../types';

export const Iron3: FC<IconProps> = ({ width = 15, height = 15, ...props }) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 15 15"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M0 7.5C0 3.35786 3.35786 0 7.5 0C11.6421 0 15 3.35786 15 7.5C15 11.6421 11.6421 15 7.5 15C3.35786 15 0 11.6421 0 7.5Z"
        fill="url(#paint0_linear_6141_57861)"
      />
      <path
        d="M4.63991 3.588H5.83991V11.988H4.63991V3.588ZM8.084 8.124V7.128C8.456 7.164 8.744 7.176 9.02 6.912C9.38 6.588 9.368 6.168 9.368 6.012C9.368 5.868 9.32 5.28 9.296 5.136C9.212 4.656 8.984 4.536 8.768 4.536C8.564 4.536 8.396 4.656 8.348 4.692C8.048 4.908 8.072 5.244 8.06 5.916H6.992C6.98 5.7 6.98 5.496 6.992 5.292C7.004 5.124 7.028 4.488 7.412 4.044C7.808 3.576 8.504 3.576 8.696 3.576C9.476 3.576 9.8 3.792 10.04 4.068C10.484 4.584 10.472 5.16 10.472 5.796C10.46 7.032 10.184 7.296 9.692 7.728C9.992 7.836 10.1 7.908 10.196 8.016C10.424 8.244 10.616 8.748 10.616 9.528C10.616 9.684 10.604 9.84 10.592 10.008C10.544 10.776 10.4 11.124 10.172 11.436C9.776 11.976 9.296 12.096 8.66 12.096C8.516 12.096 7.82 12.12 7.4 11.796C6.884 11.376 6.848 10.512 6.824 9.9H7.928C7.904 10.344 7.916 10.488 8.012 10.692C8.108 10.92 8.336 11.124 8.624 11.124C8.756 11.124 8.888 11.076 9.008 11.004C9.404 10.74 9.38 10.284 9.392 9.84C9.404 9.684 9.416 9.528 9.416 9.372C9.416 9.252 9.428 8.784 9.152 8.424C9.092 8.352 8.984 8.256 8.912 8.22C8.78 8.16 8.564 8.16 8.408 8.148C8.3 8.148 8.192 8.136 8.084 8.124Z"
        fill="#DFDFDF"
      />
      <defs>
        <linearGradient
          id="paint0_linear_6141_57861"
          x1="7"
          y1="18"
          x2="7"
          y2="-3.5"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#402F2F" />
          <stop offset="0.239" stopColor="#615E67" />
          <stop offset="0.47" stopColor="#A8A2A2" />
          <stop offset="1" stopColor="#665454" />
        </linearGradient>
      </defs>
    </svg>
  );
};
